module.exports = __webpack_public_path__ + "79432ef99228ada8e63866f8f2edef1d.svg";